import React from 'react'
import * as common from '../component/common'
import { useMediaQuery } from 'react-responsive';

const Home = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  return (
    <>
    {/* <common.floatingComponent/> */}
    { isMobile ? 
      <common.MobileBanner />
      :<common.Banner/>
    }
    {/* <common.ModernSection /> */}
    {/* <common.Amenities /> */}
    {/* {
      isMobile ?
      <common.MobileGallery />
      :<common.Gallery />
    } */}
    
    {/* <common.Facing />
    <common.Location />
    <common.Living /> */}
    {/* <common.Pricing /> */}
 
    <common.Offer />
    <common.Offer1 />
    <common.Offer2 />
    <common.Offer3 />
    <common.Offer4 />
    <common.Plan />
    <common.Visit />
    <common.Contact />
    <common.Footer />
    </>
  )
}

export default Home
